module.exports = __webpack_public_path__ + "img/secretary.780c28a0.jpg";